module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ok-image-7c5a0f45513869b76370d22d176f094a.png";